var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select-input',{attrs:{"value":_vm.value,"options":_vm.factories,"label":"name","label-renderer":_vm.renderLabel,"code":"id"},on:{"input":_vm.input}})}
var staticRenderFns = []

export { render, staticRenderFns }